import {nativeAppAdapter} from "app/employee/nativeApp/FSAcademyAndroidAdapter";
import {useEffect, useRef} from "react";
import {z} from "zod";

const messageSchema = z.discriminatedUnion("__typename", [
  z.object({__typename: z.literal("MessageNotification"), message: z.string()}),
  z.object({__typename: z.literal("ManagerBroadcast"), broadcastId: z.string(), deliveryId: z.string().optional()}),
  z.object({__typename: z.literal("LoginNotification"), accessCode: z.string()}),
  z.object({__typename: z.literal("ControlCardFillIn")}),
  z.object({
    __typename: z.literal("Ticket"),
    ticketId: z.string(),
    clientId: z.string(),
    deliveryId: z.string().nullish()
  })
]);

export type NativeNotification = z.infer<typeof messageSchema>;

export const useNativeNotification = (onNotification: (notification: NativeNotification) => void, enabled = true) => {
  const onNotificationRef = useRef(onNotification);
  useEffect(() => {
    onNotificationRef.current = onNotification;
  });

  useEffect(() => {
    if (enabled && nativeAppAdapter.isRunningInAndroidApp()) {
      const messageEventListener = (event: WindowEventMap["message"]) => {
        console.log("Message event: ", event.data);
        try {
          const data = JSON.parse(event.data);
          const parsed = messageSchema.parse(data);
          onNotificationRef.current(parsed);
        } catch (e) {
          console.warn("Failed to parse message", e);
        }
      };

      window.addEventListener("message", messageEventListener);
      console.log("Registering for Window messages");
      nativeAppAdapter.readyForMessages();

      return () => {
        console.log("Unregistering for Window messages");
        window.removeEventListener("message", messageEventListener);
      };
    }
  }, [enabled]);
};
